"use strict";

exports.__esModule = true;
exports.PlantStateActivitiesDevicesContext = void 0;
var _PlantStateActivitiesDevicesController = require("./PlantStateActivitiesDevicesController");
var _Utils = require("../../../Utils");
/**
 * Provides a configured PlantStateActivitesDevices to consumers.
 * @component
 */

var PlantStateActivitiesDevicesContext = exports.PlantStateActivitiesDevicesContext = (0, _Utils.createEnhancedContext)({
  propName: "plantStateActivitiesDevices",
  defaultController: _PlantStateActivitiesDevicesController.PlantStateActivitiesDevicesController
});